import Axios from 'axios';
import Qs from 'qs';

export default {

  // 楼栋分页列表
  listPage(
    community_id,
    build_name,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/housing/building-list-count', {
      params: {
        sort: {
          id: 'desc'
        },
        community_id,
        build_name,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加楼栋
  add(
    community_id,
    building_name,
    door_num,
    storey_num,
    storey_start_num,
    house_num,
    house_state
  ) {
    return Axios.post('/community/api/admin/housing', {
      community_id,
      building_name,
      door_num,
      storey_num,
      storey_start_num,
      house_num,
      house_state
    });
  },

  // 楼栋详情
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/housing-info/${id}`)
  },

  // 单元列表
  unitList(
    id
  ) {
    return Axios.get(`/community/api/admin/housing/${id}/doors`);
  },

  // 楼层 房屋列表 (屏蔽 启用)
  floorHouseList(
    id
  ) {
    return Axios.get(`/community/api/admin/housing/${id}/door-house-tree-enable`);
  },

  // 楼层房屋列表（状态）
  floorHouseStatusList(
    id,
    community_id
  ) {
    return Axios.get(`/community/api/admin/housing/${id}/door-house-tree-state`, {
      params: {
        community_id
      }
    });
  },

  // 获取楼栋-单元-楼层-房间任意两级节点 tree专用
  houseTree(
    id,
    community_id
  ) {
    return Axios.get(`/community/api/admin/housing/${id}/housing-two-level-tree`, {
      params: {
        community_id
      }
    });
  },

  // 批量设置户型
  batchSetHouseType(
    housing_type_id,
    housing_id
  ) {
    return Axios.patch('/community/api/admin/housing-info/batch-set-type', {
      housing_type_id,
      housing_id
    });
  },

  // 添加房屋
  addHouse(
    id,
    house_name
  ) {
    return Axios.post(`/community/api/admin/store-house/${id}`, {
      house_name
    });
  },

  // 重置单元
  resetUnit(
    id
  ) {
    return Axios.patch(`/community/api/admin/housing/${id}/initialize`);
  },

  // 重命名
  rename(
    id,
    alias
  ) {
    return Axios.patch(`/community/api/admin/housing/${id}/alias`, {
      alias
    });
  },

  // 开启单元 楼层
  enable(
    housing_id
  ) {
    return Axios.patch('/community/api/admin/housing/shield-door-storey', {
      housing_id,
      is_enable: 1
    });
  },

  // 屏蔽单元 楼层
  disable(
    housing_id
  ) {
    return Axios.patch('/community/api/admin/housing/shield-door-storey', {
      housing_id,
      is_enable: 0
    });
  },

  // 开启房屋
  enableHouse(
    housing_ids
  ) {
    return Axios.patch('/community/api/admin/housing/batch-shield-house', {
      housing_ids,
      is_enable: 1
    });
  },

  // 屏蔽房屋
  disableHouse(
    housing_ids
  ) {
    return Axios.patch('/community/api/admin/housing/batch-shield-house', {
      housing_ids,
      is_enable: 0
    });
  },

  // 覆盖
  cover(
    housing_sample_id,
    housing_copy_ids
  ) {
    return Axios.post('/community/api/admin/housing/copy-tree', {
      housing_sample_id,
      housing_copy_ids
    });
  },

  // 房屋详情
  houseInfo(
    id
  ) {
    return Axios.get(`/community/api/admin/housing-info/${id}/type-show`);
  },

  // 房屋住户信息
  houseResidentInfo(
    id
  ) {
    return Axios.get(`/community/api/admin/housing/${id}/housing-owner`);
  },

  // 房屋车位信息
  houseParkingInfo(
    id
  ) {
    return Axios.get(`/community/api/admin/housing/${id}/parking-info`);
  },

  // 删除楼栋
  del(
    id,
    community_id
  ) {
    return Axios.delete(`/community/api/admin/housing/${id}`, {
      params: {
        community_id
      }
    });
  },

  // 复制楼栋
  copy(
    id
  ) {
    return Axios.post(`/community/api/admin/housing/${id}/copy-build`, {
      copy_num: 1
    });
  },

  // 获取房屋分页列表
  houseListPage(
    community_id,
    housing_id,
    alias,
    house_state,
    state,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/get-house-by-frame', {
      params: {
        community_id,
        housing_id,
        alias,
        house_state,
        state,
        page,
        limit
      }
    });
  }

}